import * as Yup from 'yup';
import { UploadFile } from '@ui';

export interface IMedicalRecordForm {
  name: string;
  dateOfMedicalRecord: [Date];
  medicalRecordFile?: UploadFile[];
}

export const initialValues: IMedicalRecordForm = {
  name: '',
  dateOfMedicalRecord: [new Date()],
  medicalRecordFile: [],
};

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('validation.required'),
  dateOfMedicalRecord: Yup.array(Yup.date())
    .required('validation.required')
    .min(1, 'validation.required'),
  medicalRecordFile: Yup.array().of(Yup.mixed()).min(1, 'validation.required'),
});
